import { createAsyncAction } from "./utils";

export const userChange = createAsyncAction("NOTIFY/GET_USER_CHANGE");

export const spaceChange = createAsyncAction("NOTIFY/GET_SPACE_CHANGE");
